
import { useIsDutchiePay } from './use-is-dutchie-pay';
import { useIsRethink } from './use-is-rethink';

export function useHasPreauth(): boolean {
  const isRethink = useIsRethink();
  const isDutchiePay = useIsDutchiePay();
  return isRethink || isDutchiePay;
};
